// extracted by mini-css-extract-plugin
export default {"container":"styles_container__BYmmy","label":"styles_label__yv7IF","icon":"styles_icon__4p6d+"};